import { Component, OnInit, ChangeDetectionStrategy, Input, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { format } from 'date-fns';
import { PDialogFooterBtnActionType } from '@frontend-site/ui/components';
import { UserService } from '@frontend-site/users/domain';

@Component({
    selector: 'p-view-all-licenses-dialog',
    templateUrl: './view-all-licenses-dialog.component.html',
    styleUrls: ['./view-all-licenses-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewAllLicensesDialogComponent implements OnInit {
    viewAllLicenses$ = this.userService.getUserSubscriptions(this.data.companyId);

    constructor(private readonly userService: UserService, @Inject(MAT_DIALOG_DATA) public data: { companyId: number }) {}

    formatDate(date: Date | undefined) {
        return date ? format(date, 'd-MMM-yyyy') : null;
    }

    formatAccountName(name: any) {
        return `${name.account}(${name.company})`;
    }

    ngOnInit(): void {}

    get footerConfig() {
        return [
            {
                type: PDialogFooterBtnActionType.Close,
                text: 'Actions.close'
            }
        ];
    }
}
